import { OneWayInServiceUpsertDto } from 'src/api/v2';
import useServiceSubForm, { extractSubData, SubFormProps, SubFormReturn } from '../use-service-sub-form';

export type EeaFields = 'selectedEeaArticles' | 'eeaComments';
export type EeaData = Pick<OneWayInServiceUpsertDto, EeaFields>;

const useEeaForm = ({
  data,
  updateData,
  errors,
  setErrors,
}: SubFormProps<EeaData>): SubFormReturn<EeaData, EeaFields> => {
  const rules: Partial<Record<keyof OneWayInServiceUpsertDto, any>> = {
    eeaComments: {
      maxLength: { value: 500, message: 'Maksimalt 500 tegn' },
    },
  };

  const extractEeaFields = (data: OneWayInServiceUpsertDto): EeaData => {
    return extractSubData(data, ['selectedEeaArticles', 'eeaComments']);
  };
  const eeaFields = extractEeaFields(data);
  const { form } = useServiceSubForm<EeaData>(eeaFields, updateData, errors, setErrors);
  const registerWithRules = (field: EeaFields) => form.register(field, rules[field]);
  return { form, rules, registerWithRules };
};

export default useEeaForm;
